import { render, staticRenderFns } from "./OsPasswordInformationItem.vue?vue&type=template&id=15b845c0&scoped=true"
import script from "./OsPasswordInformationItem.vue?vue&type=script&lang=ts"
export * from "./OsPasswordInformationItem.vue?vue&type=script&lang=ts"
import style0 from "./OsPasswordInformationItem.vue?vue&type=style&index=0&id=15b845c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b845c0",
  null
  
)

export default component.exports